<div class="row mb-5">
  <div class="col-2">
    <div #columnSwitcherDropdown>
      <button
        lib-icon-btn
        icon
        iconType="list"
        [ngClass]="{
          'btn--icon--list--active': accountDropdownMenu.showing
        }"
        (click)="dropdownToggle(accountDropdownMenu)"
      ></button>
      <lib-dropdown
        [reference]="columnSwitcherDropdown"
        [startPosition]="'bottom'"
        [config]="{
          maxHeight: '300px',
          minWidth: '200px'
        }"
        #accountDropdownMenu
      >
        <div class="drop-down">
          <div class="drop-down-title text-center">
            {{ title | uppercase }}
          </div>

          <overlay-scrollbars class="drop-down-content">
            <ul class="drop-down-content__list">
              <li class="drop-down-content__item">
                <lib-radio-checkbox
                  (change)="setHideValues($event)"
                  [checked]="isAllSelected"
                  type="checkbox"
                  value="item.value"
                  >{{ selectAllTitle }}</lib-radio-checkbox
                >
              </li>
              <li
                *ngFor="let column of columnDefs"
                class="drop-down-content__item"
                [class.drop-down-content__item--required]="isRequired(column)"
              >
                <lib-radio-checkbox
                  (change)="
                    setColumnsVisibility(
                      column.colId ? column.colId : column.field,
                      $event
                    )
                  "
                  [checked]="isRequired(column) || !column.hide"
                  [disabled]="isRequired(column)"
                  type="checkbox"
                  value="item.value"
                  >{{ column.headerName }}</lib-radio-checkbox
                >
              </li>
            </ul>
          </overlay-scrollbars>
        </div>
      </lib-dropdown>
    </div>
  </div>
</div>
